import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Company, QueryParams } from '../types';
import { getCompanies } from '../utils/httpRequest';
import { RootState } from '../store';
import _ from 'lodash';

export interface CompanyState {
  companies: Company[];
  company?: Company;
  loading: boolean;
  error?: string;
}

const initialState: CompanyState = {
  companies: [],
  loading: false,
};

export const fetchCompanies = createAsyncThunk(
  'companies/fetchCompanies',
  async (params?: QueryParams) => {
    const companies = await getCompanies();

    return companies;
  }
);

export const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    setCompanies: (state, action: PayloadAction<Company[]>) => {
      state.companies = action.payload;
    },
    setCompany: (state, action: PayloadAction<Company>) => {
      state.company = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanies.pending, (state) => {
        state.loading = true;
        state.error = '';
      })
      .addCase(fetchCompanies.fulfilled, (state, action) => {
        state.companies = _.reverse(action.payload);
        state.loading = false;
        state.error = '';
      })
      .addCase(fetchCompanies.rejected, (state, action) => {
        state.error = 'Get Company List Failed.';
        state.loading = false;
      });
  },
});

export const { setCompanies, setCompany } = companySlice.actions;

export default companySlice.reducer;

export const selectCompanies = (state: RootState) =>
  state.companies.companies || [];

export const selectCompany = (state: RootState) => state.companies.company;

export const selectIsFetchingCompany = (state: RootState) =>
  state.companies.loading;
